import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewEncapsulation,
} from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Dictionary } from "highcharts";
import { ChartsPageDataService } from "../../charts-page/charts-page-data.service";
import { VAIconRegistryService, search } from "@va/core-library/icons";

class TickerInfo {
  ticker: string;
  full_name: string;
  bTicker: string;
  mpt: number;
  cid: number;

  constructor(sn: string, n: string, bt: string, mpt: number, cid: number) {
    this.ticker = sn;
    this.full_name = n;
    this.bTicker = bt;
    this.mpt = mpt;
    this.cid = cid;
  }
}

@Component({
  selector: "app-comparative-ticker-search",
  templateUrl: "./comparative-ticker-search.component.html",
  styleUrls: ["./comparative-ticker-search.component.scss"],
  host: { class: "ticker-search-host" },
  encapsulation: ViewEncapsulation.None,
})
export class ComparativeTickerSearchComponent implements OnInit {
  @Input() onScreen?: boolean;
  @Input() tickers?: Array<string>;
  @Input() selectedOption?: Array<any>;
  @Input() watchlistData;
  @Input() industryData;
  @Input() marketGeoData;
  @Input() isComp: boolean;
  @Input() showSelectedValue: boolean;
  @Input() hasSearchIcon: boolean;
  @Input() disabled: boolean;
  @Input() placeholder = "Search companies or lists";
  @Input() maxSelectedTickerCount;
  @Input() isTickerTypeBg = false;
  @Input() isCreateNewModalIndustryMenu: boolean = false;
  isSearchMenuVisible: boolean = false;
  isVisibleEditTickerModal = false;
  @Output() tickerToEmit: EventEmitter<TickerInfo> =
    new EventEmitter<TickerInfo>();
  @Output() onSearchedTickerUpdate = new EventEmitter();
  @Output() handleMenuApply: EventEmitter<any> = new EventEmitter();
  @Output() handleTickerMenuChange: EventEmitter<any> = new EventEmitter();
  @Input() suggestedTickers = [];
  @Input() recentlyVisitedTickers = [];
  @Input() menuList;

  tickerSearchTextchanged: Subject<string> = new Subject<string>();
  searchResult: Array<TickerInfo> = [];
  apiUrl: string = window.apiUrl;
  selectedTicker: TickerInfo;
  showDropdown = false;
  queryString: string;
  api: string;
  isTickerSearchApiDataReady = false;

  constructor(
    private http: HttpClient,
    private chartsDataService: ChartsPageDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([search]);
  }

  searchTicker(query: string) {
    this.queryString = query;
    this.tickerSearchTextchanged.next(query);
    if (this.queryString.length) {
      this.isSearchMenuVisible = false;
    } else {
      const ele = document.getElementById("input-searchbox");
      // Timeout is to ensure that the menu is visible only after previously opened search results are collapsed
      setTimeout(() => {
        if (document.activeElement === ele) {
          this.isSearchMenuVisible = true;
        }
      }, 400);
    }
  }

  getCompanyTickerInfo(query: string): void {
    if (this.isComp) {
      this.api = `comps/get_search_tickers`;
    } else {
      this.api = `api/n_tiksch`;
    }
    if (query.trim().length) {
      this.http
        .get(`${this.apiUrl}/${this.api}?q=${query}&ticker_filter=true`)
        .subscribe((response: Dictionary<any>) => {
          if (
            response.srhData &&
            response.srhData.Company &&
            response.srhData.Company.data
          ) {
            const tickerInfoList: Array<Dictionary<string | number>> =
              response.srhData.Company.data;
            this.searchResult = tickerInfoList.map(
              (info: Dictionary<string | number>) => {
                return new TickerInfo(
                  info.sn as string,
                  info.n as string,
                  info.bt as string,
                  info.mpt as number,
                  info.cid as number,
                );
              },
            );
          } else {
            this.searchResult = [];
            console.error("Invalid format of response object");
          }
          this.showDropdown = true;
          this.isTickerSearchApiDataReady = true;
        });
    } else {
      this.searchResult = [];
      this.showDropdown = false;
      this.isTickerSearchApiDataReady = true;
    }
  }

  onChangeTicker(value: TickerInfo) {
    //clear current selection after emitting
    if (this.onScreen === true) {
      const tickers = [...this.tickers, value.ticker];
      const tickerDetail = { tickers, value };
      this.onSearchedTickerUpdate.emit(tickerDetail);
      setTimeout(() => (this.selectedTicker = null), 100);
    } else {
      this.tickerToEmit.emit(value);
      if (!this.showSelectedValue) {
        setTimeout(() => (this.selectedTicker = null), 100);
      }
      this.searchResult = [];
    }
  }

  // For resetting/changing value from outside
  changeValue(value) {
    this.selectedTicker = value;
  }

  showEditTickersModal() {
    this.isVisibleEditTickerModal = true;
  }

  onCloseEditTickersModal = (ev) => {
    if (ev === true) this.isVisibleEditTickerModal = false;
  };

  ngOnInit() {
    this.tickerSearchTextchanged
      .pipe(
        tap(() => {
          this.isTickerSearchApiDataReady = false;
        }),
        debounceTime(500),
        distinctUntilChanged(),
      )
      .subscribe((q) => {
        this.getCompanyTickerInfo(q);
      });
  }

  handleApply(data) {
    this.isSearchMenuVisible = false;
    this.handleMenuApply.emit(data);
  }

  handleMenuChange(data) {
    this.handleTickerMenuChange.emit(data);
  }
}
